import axios , { AxiosError, AxiosInstance } from 'axios';

import { ConfirmInfo, ConfirmOrder, Packet, PacketURL } from './Models';

export class RestClient {
    private static instance: RestClient;

    private static baseURL: string;
    private static apiKey: string;

    private axcli: AxiosInstance | null = null;

    private constructor() {
        console.log('base url: ' + RestClient.baseURL);
        //this.axcli = axios.create({ baseURL: RestClient.baseURL, headers: { 'api-key':  RestClient.apiKey } });
        this.axcli = axios.create({ baseURL: RestClient.baseURL});
        this.axcli.interceptors.request.use(request => {
            //Logger.log('Request:', request);
            return request;
        }, (err) => {
            //Logger.error('Request error:', err);
            return err;
        });
        this.axcli.interceptors.response.use(response => {
            //Logger.log('Response:', response);
            if (response.data) {
                //Logger.log('Data:', JSON.stringify(response.data));
            }
            return response;
        }, (err) => {
            //Logger.error('Response error:', err);
            throw err;
        });
    }

    private createClient() {

    }

    static init(bu: string | null | undefined, apiKey: string | null | undefined) {
        if (bu == null || bu.trim().length === 0) {
            bu = window.location.protocol+'//'+window.location.host;
        }
        RestClient.baseURL = bu;
        RestClient.apiKey = '5f55b3c6-cee4-4013-9b79-7bae81c0347f';
        if (apiKey) {
            RestClient.apiKey = apiKey;
        }
        // Devo ricreare il client
        RestClient.instance = new RestClient();
    }

    static getBaseURL(): string {
        return RestClient.baseURL;
    }

    static getImageURL(imgPath: string) {
        if (imgPath) {
            if (!imgPath.trim().toLowerCase().startsWith('http')) {
                imgPath = RestClient.getBaseURL() + imgPath;
            }
        }

        return imgPath;
    }

    static getInstance(): RestClient {
        if (!RestClient.instance) {
            RestClient.instance = new RestClient();
        }

        return RestClient.instance;
    }

    public findPackets(date: string): Promise<Packet[]> {
        return new Promise<Packet[]>((resolve, reject) => {
            this.axcli?.get<Packet[]>('/api/sale/packets/'+date).then((res) => {
                try {
                    resolve(res.data);
                }
                catch (err) {
                    reject('Errore ricerca pacchetti: ' + err);
                }
            }).catch((reason) => {
                reject('Errore ricerca pacchetti: ' + reason);
            });
        });
   }

   public getPacket(id: string): Promise<Packet> {
        return new Promise<Packet>((resolve, reject) => {
            this.axcli?.get<Packet>('/api/sale/packets/packet/'+id).then((res) => {
                try {
                    resolve(res.data);
                }
                catch (err) {
                    reject('Errore recupero info pacchetto: ' + err);
                }
            }).catch((reason) => {
                reject('Errore recupero info pacchetto: ' + reason);
            });
        });
    }

    public orderPacket(id: string, email: string, lang: string): Promise<ConfirmInfo> {
        return new Promise<ConfirmInfo>((resolve, reject) => {
            this.axcli?.post('/api/sale/packets/packet/'+id+'/order',{email: email, lang: lang}).then((res) => {
                try {
                    if (res.data) {
                        resolve(res.data);
                    } else {
                        reject('Codice ordine non ricevuto');
                    }
                }
                catch (err) {
                    reject('Errore creazione ordine pacchetto: ' + err);
                }
            }).catch((reason) => {
                reject('Errore creazione ordine pacchetto: ' + reason);
            });
        });
    }

    public confirmOrderPacket(id: string, orderid: string, confirmCode: string, lang: string, paypal: boolean, paylink?: string): Promise<ConfirmOrder> {
        return new Promise<ConfirmOrder>((resolve, reject) => {
            this.axcli?.post('/api/sale/packets/packet/'+id+'/order/confirm',{orderid: orderid, confirmCode: confirmCode, lang: lang, paylink: paylink, paypal: paypal?'S':'N'}).then((res) => {
                try {
                    resolve(res.data);
                }
                catch (err) {
                    reject('Errore conferma ordine pacchetto: ' + err);
                }
            }).catch((reason) => {
                const aErr = reason as AxiosError;
                if (aErr.response && aErr.response.status === 404) {
                    reject('errInvalidCode');
                } else {
                    reject('Errore conferma ordine pacchetto: ' + reason);
                }
            });
        });
    }

    public capturePaypalOrder(id: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.axcli?.post('/api/sale/packets/packet/'+id+'/order/capture',{}).then((res) => {
                try {
                    resolve();
                }
                catch (err) {
                    reject('Failed to manage paypal order: ' + err);
                }
            }).catch((reason) => {
                reject('Failed to manage paypal order: ' + reason);
            });
        });
    }


    public gotoPacket(id: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.axcli?.get<PacketURL>('/api/sale/packets/packet/'+id+'/goto').then((res) => {
                try {
                    resolve(res.data.packetURL);
                }
                catch (err) {
                    reject('Errore recupero info pacchetto: ' + err);
                }
            }).catch((reason) => {
                reject('Errore recupero info pacchetto: ' + reason);
            });
        });
    }

}